import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const getTarget = () => {
  const now = new Date();
  const year = now.getMonth() === 11 && now.getDate() > 25 ? now.getFullYear() + 1 : now.getFullYear();
  return new Date(year, 11, 25, 0, 0, 0);
};

const Cell = ({ value, label, color }) => (
  <div className="flex flex-col items-center">
    <span
      className={`font-jbmono text-sm sm:text-base font-bold px-1.5 sm:px-2 py-0.5 rounded ${color}`}
      data-testid={`countdown-${label.toLowerCase()}`}
    >
      {String(value).padStart(2, "0")}
    </span>
    <span className="text-[9px] font-jbmono uppercase tracking-widest text-cream/50 mt-0.5">{label}</span>
  </div>
);

export const CountdownBar = () => {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, getTarget() - new Date());
      const sec = Math.floor(diff / 1000);
      setT({
        d: Math.floor(sec / 86400),
        h: Math.floor(sec / 3600) % 24,
        m: Math.floor(sec / 60) % 60,
        s: sec % 60,
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="countdown-bar"
      className="w-full bg-midnight border-b border-steel/60 px-4 py-2 flex items-center justify-center gap-3 sm:gap-6 flex-wrap"
    >
      <span className="flex items-center gap-2 font-jbmono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-gold">
        <Sparkles className="w-3.5 h-3.5" />
        Officially on sale Christmas Day
      </span>
      <div data-testid="countdown-timer" className="flex items-center gap-2 sm:gap-3">
        <Cell value={t.d} label="Days" color="bg-crimson text-white" />
        <span className="text-cream/40 font-bold">:</span>
        <Cell value={t.h} label="Hrs" color="bg-cream text-navy" />
        <span className="text-cream/40 font-bold">:</span>
        <Cell value={t.m} label="Min" color="bg-[#1D4ED8] text-white" />
        <span className="text-cream/40 font-bold">:</span>
        <Cell value={t.s} label="Sec" color="bg-crimson text-white" />
      </div>
    </div>
  );
};
